import { ProductionBundles, ProductionBundleSubdomains } from '@hcs/types';

export const useBundleId = () => {
  const bundleSubdomain = window.location.host.split('.')[0] as
    | ProductionBundleSubdomains
    | undefined;

  switch (bundleSubdomain) {
    case ProductionBundleSubdomains.SolutionsPlatform: {
      return ProductionBundles.SolutionsPlatform;
    }
    case ProductionBundleSubdomains.CanaryCommand: {
      return ProductionBundles.CanaryCommand;
    }
    default: {
      return ProductionBundles.SolutionsPlatform;
    }
  }
};
